import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function StatsTab() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/admin/stats")
      .then((r) => { if (!cancelled) setStats(r.data); })
      .catch((err) => console.error("Falha ao carregar estatísticas:", err));
    return () => { cancelled = true; };
  }, []);

  if (!stats) return <p className="text-slate-400 text-sm">Carregando...</p>;

  const items = [
    { label: "Inscritos", value: stats.participants },
    { label: "Contas ativadas", value: stats.activated },
    { label: "Certificados liberados", value: stats.certificates },
    { label: "Moderadores", value: stats.moderators },
    { label: "Salas", value: stats.rooms },
    { label: "Mensagens no chat", value: stats.messages },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="admin-stats">
      {items.map((i) => (
        <div key={i.label} className="card-metric">
          <p className="text-xs font-data tracking-wider uppercase text-slate-500">{i.label}</p>
          <p className="text-3xl font-heading font-bold text-white mt-2">{i.value}</p>
        </div>
      ))}
    </div>
  );
}
